import { render, staticRenderFns } from "./recurso-acessibilidade-deficiente-visual.vue?vue&type=template&id=793fb52c&"
import script from "./recurso-acessibilidade-deficiente-visual.vue?vue&type=script&lang=ts&"
export * from "./recurso-acessibilidade-deficiente-visual.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins-hml/workspace/pracessivel-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('793fb52c')) {
      api.createRecord('793fb52c', component.options)
    } else {
      api.reload('793fb52c', component.options)
    }
    module.hot.accept("./recurso-acessibilidade-deficiente-visual.vue?vue&type=template&id=793fb52c&", function () {
      api.rerender('793fb52c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pessoa-deficiente-visual/recurso-acessibilidade-deficiente-visual.vue"
export default component.exports